import React, { useState, useRef, useEffect } from 'react';
import '../App.css'; 
import './encuesta/SurveyComponent.css';
import './encuesta/LoadingEffect.css';
import { 
    FaArrowDown, 
    FaDownload,
    FaRedo, 
    FaCaretDown, 
    FaArrowRight, 
    FaSignInAlt, 
    FaSignOutAlt,
} from 'react-icons/fa'; 
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from '@apollo/react-hooks';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import Terminos from './terminosDeUso';
import Suscripciones from './suscripciones';
import './Modal.css';
import FilteredPosts from './historialLinks_recto';
import useScrollToBottom from './modulos-propios/useScrolledToBottom'; 
import useClickOutside from './modulos-propios/useClickOutside'; 
import Nuevo from './icons/nuevo';
import AbrirSide from './icons/arrowLeft';
import CerrarSide from './icons/arrowRigth';
import client from '../apolloClient';
import { useLocation  } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import ToolTipBarra from './icons/TooltipBarra';

const VERIFY_EMAIL_QUERY = gql`
  query VerifyEmail($email: String!) {
    verifyEmail(email: $email) {
      exists
    }
  }
`;

const Chat = () => {
  const [showSidebar, setShowSidebar] = useState(true); 
   const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  useClickOutside(showDropdown, setShowDropdown); 
  const [currentChat, setCurrentChat] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuscripcionesOpen, setSuscripcionesOpen] = useState(false);
  const [messageInput, setMessageInput] = useState('');
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [emailExists, setEmailExists] = useState(null);
  const [title, setTitle] = useState('');
  const [info, setInfo] = useState('');
  const [message, setMessage] = useState('');
  const messagesEndRef = useRef(null);
  const bodymessagesEndRef = useRef(null);
  const isScrolledToBottom = useScrollToBottom(bodymessagesEndRef); 
  const { user, isAuthenticated, isLoading } = useAuth0();
  const [showLoading, setShowLoading] = useState(false);
  const [inputView, setinputView] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState(<span className='loading-text'>Procesando informacion. Creando Link...</span>);
  const { loginWithRedirect } = useAuth0();
  const { logout } = useAuth0();
  const navigate = useNavigate();
  
  const [submitPostrain] = useMutation(CREATE_LINK_MUTATION);
  const [submitPostLinkPermiso] = useMutation(SEND_MAIL_LINK_PERMISO);

  const { data: emailData, refetch: refetchEmail } = useQuery(VERIFY_EMAIL_QUERY, {
    variables: { email },
    skip: true,
    onCompleted: (data) => setEmailExists(data.verifyEmail.exists),
  });

  const useradmin = [
    process.env.REACT_APP_ADMIN,
    process.env.REACT_APP_ADMIN2,
    process.env.REACT_APP_ADMIN3,
    process.env.REACT_APP_ADMIN4,
    process.env.REACT_APP_ADMIN5,
    process.env.REACT_APP_ADMIN6
  ];

  const isAdmin = (currentUser) => {
    return useradmin.includes(currentUser);
  };

  const handleEmailSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      setMessage('Por favor ingrese un correo válido.');
      return;
    }
    setMessage('');
    try {
      const { data } = await refetchEmail({ email }); // Ejecuta la consulta manualmente
      setEmailExists(data.verifyEmail.exists);
      setStep(2);
    } catch (error) {
      console.error('Error al verificar el correo:', error);
    }
  };
  

  const handleEmailSubmit2 = async (event) => {
    //event.preventDefault();
    setEmailExists(true)
    setMessage('');
    //await refetchEmail();
    setStep(2);
  };

  

  const handleTitleSubmit = (event) => {
    event.preventDefault();
    if (title.trim() === '') {
      setMessage('Por favor ingresa un título.');
    } else {
      setMessage('');
      setStep(4);
    }
  };

  const handleInfoSubmit = (event) => {
    event.preventDefault();
    if (info.trim() === '') {
      setMessage('Por favor ingresa la información denominada cuerpo.');
    } else {
      setMessage('');
      setinputView(false);
      handleNewPostrain();
      setShowLoading(true);
    }
  };
  
  const username = user?.sub?.replace(/[^a-zA-Z0-9]/g, '');

  const { loading, error, data, refetch } = useQuery(FETCH_POSTS_QUERY_USER_LINK, {
    variables: { username }
  });


  const location = useLocation();

  useEffect(() => {
    if (location.state?.refetchNeeded) {
      refetch();
    }
  }, [location.state, refetch]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setShowSidebar(false);
      }
    };
    handleResize(); 
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [botResponses, setBotResponses] = useState([]);
  useEffect(() => {
    const newBotResponses = currentChat.filter(message => message.sender === 'bot' && !botResponses.includes(message.text));
    setBotResponses(prevBotResponses => [
      ...prevBotResponses,
      ...newBotResponses.map(message => message.text)
    ]);
  }, [currentChat, messageInput]);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
    }
  };

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const handleRegenerate = () => {
  };

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const [createdPost, setCreatedPost] = useState(null);

  const createPostMutation = () => {
    return client.mutate({
      mutation: CREATE_LINK_MUTATION,
      variables: { titulo: title , cuerpo: info, username: username , email: user.email},
      onCompleted: (data) => {
        console.log('Mutación completada: ', data);
      },
      onError: (error) => {
        console.error('Error en la mutación: ', error);
      }
    });
  };

  const createPostLinkPermiso = () => {
    return client.mutate({
      mutation: SEND_MAIL_LINK_PERMISO,
      variables: { email: email, solicitanteLinkid: username},
      onCompleted: (data) => {
        console.log('Mutación completada: ', data);
      },
      onError: (error) => {
        console.error('Error en la mutación: ', error);
      }
    });
  };

  const callCreatePost = async (refetch) => {
    try {
      const response = await createPostMutation();
      console.log("Llamada a createPostMutation exitosa:", response.data.createLinksTests.id);
      const postId = response.data.createLinksTests.id;
      await refetch();
      setShowLoading(false);
      navigate(`/estadoLink/${postId}`);
    } catch (error) {
      console.error("Error al llamar a createPostMutation:", error);
    }
  };

  const callCreatePostPermiso = async (refetch) => {
    try {
      const response = await createPostLinkPermiso();
      console.log("Llamada a createPostMutation exitosa:", response.data.sendmailLink.id);
      const postId = response.data.sendmailLink.id;
      await refetch();
      setShowLoading(false);
      navigate(`/estadoLink/${postId}`);
    } catch (error) {
      console.error("Error al llamar a createPostMutation:", error);
    }
  };

  const handleNewPostrain = () => {
    callCreatePost(refetch);
  };

  const handleNewPostMail = () => {
    setShowLoading(true);
    callCreatePostPermiso(refetch);
    
  };

  const handleChatNavigation = () => {
    localStorage.clear()
    navigate(`/new/chat`); // Navega a la página del chat
    //setSelectedUser('Selecionar usuario');
  };

  const handleSupervisar = () => {
    localStorage.clear()
    navigate(`/miequipo`)
  };
 

  return (
    <div className="chat-container">
      {!createdPost && showLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>{loadingMessage}</div>
      ) : (
        <div className={`spinner-container ${!sidebarOpen && 'expanded'}`}> 
        <div className="contexto-container" >
          <h3>Generar link de Conductual-GPT</h3>
          <p>Por favor, ingrese la información necesaria para generar el enlace...</p>
          <p class="warning">Ingrese datos reales de la persona que completará el test. De lo contrario, los resultados obtenidos podrían no ser precisos ni útiles.</p>
          <p class="info"> En el campo de información, ingrese detalles como el puesto al que aplicará o alguna característica que le permita identificar y encontrar fácilmente el enlace generado más adelante.</p>
        </div>
      </div>
      )}
      <div className="floating-menu">
      {isAuthenticated && ( <img src='/images/LOGO-conductualGPT-01.svg' className={`floating-menu-logo-2 ${!sidebarOpen && 'collapsed'}`} /> )}
        <div className="sidebar-buttons">
          {!isAuthenticated && (
            <button onClick={() => loginWithRedirect()}>
              <FaSignInAlt />
              <span>Ingresar</span>
            </button>
          )}
        </div>
        {isAuthenticated && (
          <div className="profile-container">
            <div id="dropdown" className="dropdown">
            <img src={user.picture} alt={user.name} onClick={handleDropdownToggle}/>
              {showDropdown && (
                <div className="dropdown-menu">
                  
                  
                    <button>
                        <a className='button-link' href="#" onClick={handleChatNavigation}>Inicio</a>
                     </button>

                     <button>
                         <a className='button-link' href="#" onClick={() => navigate(`/equipos`)}>Crear equipo</a>
                     </button>
                   
                    {isAdmin(user.sub) && ( <button><a className='button-link' href="#" onClick={handleSupervisar}>Supervisar</a></button>)}
                  <button >
                     <a className='button-link' href="#" onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>Salir</a>
                    <FaSignOutAlt className="icon-spacing"/>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {isAuthenticated && (
           <div>
                  <ToolTipBarra sidebarOpen={sidebarOpen} content={sidebarOpen ? 'Cerrar barra lateral' : 'Abrir barra lateral'}>
                   <button 
                     className={`sidebar-toggle ${!sidebarOpen && 'collapsed'}`}
                     onClick={() => setSidebarOpen(!sidebarOpen)}
                     style={{
                       position: 'fixed',
                       left: sidebarOpen ? '206px' : '20px',
                       top: '6px',
                       zIndex: 1000,
                       transition: 'all 0.3s ease',
                       background: '#fff',
                       border: '0px solid #ddd',
                       borderRadius: '50%',
                       width: '33px',
                       height: '33px',
                       display: 'flex',
                       alignItems: 'center',
                       justifyContent: 'center',
                       cursor: 'pointer'
                     }}
                   >
                     {sidebarOpen ? '✕' : '☰'}
                   </button>
                 </ToolTipBarra>
                        <div className={`sidebar ${!sidebarOpen && 'closed'}`}>
              
                        <div className="history-section">
                          <p>Historial</p>
                          <FilteredPosts refetch={refetch} user={user.sub}/>
                        </div>
                      </div>         
         </div>
      )}
      <div className={`main ${!sidebarOpen && 'expanded'}`}>
        {isAuthenticated && (
          <div className="input-container">
            {step === 1 && (
             <form onSubmit={handleEmailSubmit}>
             <label>
               Ingresar email del destinatario
               <input
                
                 placeholder="Ingresar email del destinatario..."
                 type="email"
                 value={email}
                 onChange={(e) => setEmail(e.target.value)}
               />
             </label>
             <button type="submit" ><FaArrowRight size={15} /></button>
             {message && <p style={{ color: 'red' }}>{message}</p>}
           </form>
            )}
            {step === 2 && (
              emailExists ? (
                <div
                   style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    marginLeft: '70px'
                 }}
                >
                <label
                class="warning"
                    style={{
                    marginBottom: '40px',
                    }}
                >
                    Este correo ya tiene un test completado. ¿Qué desea hacer?
                </label>

                <div style={{ marginBottom: '20px' }}>
                    <button
                    className="navi-button"
                    style={{ marginBottom: '10px' }} // Opcional para separar botones
                    onClick={handleNewPostMail}
                    >
                    Solicitar que comparta información
                    </button>
                    <button
                    className="navi-button"
                    onClick={() => setStep(3)}
                    >
                    Solicitar que complete un nuevo test
                    </button>
                </div>
              </div>

              ) : (
                setStep(3)
              )
            )}
            {step === 3 && (
              <form onSubmit={handleTitleSubmit}>
                <label>
                  Ingresar nombre del destinatario
                  <input
                    type="text"
                    placeholder="Ingresar nombre del destinatario..."
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </label>
                <button type="submit" ><FaArrowRight size={15} /></button>
                {message && <p style={{ color: 'red' }}>{message}</p>}
              </form>
            )}
            {step === 4 && inputView === true && (
              <form onSubmit={handleInfoSubmit}>
                <label>
                Ingrese la información o descripción del puesto para el cual se está considerando al candidato.
                  <input
                    type="text"
                    placeholder="Ingresar información del puesto..."
                    value={info}
                    onChange={(e) => setInfo(e.target.value)}
                  />
                </label>
                <button type="submit" ><FaArrowRight size={15} /></button>
                {message && <p style={{ color: 'red' }}>{message}</p>}
              </form>
            )}
          </div>
        )}
        <div className="disclaimer-base-container">
          <p>Copilot Nawi-GPT ™ 2025 | by Neuraldinamica LLC</p>
          <a className='button-link2' href="#" onClick={() => setIsModalOpen(true)}>Términos de uso.</a>
        </div>
      </div>
      {isAuthenticated && (
        <>
          {bodymessagesEndRef.current && isScrolledToBottom === false && (
            <div className="scroll-to-bottom" onClick={scrollToBottom}>
              <FaArrowDown />
            </div>
          )}
        </>
      )}
      <div className="disclaimer-base-container-terminos">
       
        <Terminos isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <Suscripciones isOpen={isSuscripcionesOpen} onClose={() => setSuscripcionesOpen(false)} />
      </div>
    </div>
  );
};




const FETCH_POSTS_QUERY_USER_LINK = gql`
  query getPostsLinkByUsername($username: String!) {
    getPostsLinkByUsername(username: $username) {
      id
      linkOwner
      destinatario
      estado
      informacion
      createdAt
    }
  }
`;


const CREATE_LINK_MUTATION = gql`
mutation($titulo: String!, $cuerpo: String!, $username: String!, $email: String!){
  createLinksTests(titulo: $titulo, username: $username, cuerpo: $cuerpo, email: $email) {
    id
    destinatario
    informacion
    linkOwner
    createdAt
    vectorcreatedAt
  }
  
}
`;


const SEND_MAIL_LINK_PERMISO = gql`
mutation($email: String!, $solicitanteLinkid: String!){
    sendmailLink(email: $email, solicitanteLinkid: $solicitanteLinkid){
        id
    }
  }
`;




export default Chat;

